import { ICommand, IDefineCommand } from 'core-ts-types';

angular
  .module('capability-ng-appointments')
  .factory(
    'clearAppointmentsCacheOnServerCommand',
    (defineCommand: IDefineCommand, $http: ng.IHttpService, log: any): ICommand => {
      return defineCommand('clearAppointmentsCacheOnServerCommand', (deferred: ng.IDeferred<any>): void => {
        $http({
          url: 'ssccampus/appointment/cache/',
          method: 'POST'
        }).then(
          (response: any) => {
            deferred.resolve(response);
          },
          () => {
            log.error('Unable to clear appointment cache');
            deferred.reject();
          }
        );
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/clear_appointments_cache_on_server_command.ts